<template>
<div class="goodsListBig_ui">
    <div class="goods-list-big">
        
        <van-cell v-for="(item,i) in goodsListData" :key="i" class="goods-box">
            <div class="box" v-if="goodsListData.length>0&&(i<number||number==-1)" @click="goGoodsDetail(item,i)" :class="{'box-square':isSquarePic=='T'}">
                <div class="img-box">
                    <div class="img-box-content">
                        <div class="label" v-if="item.goodsCity&&item.goodsCity!=''">
                            {{item.goodsCity|keyFilter}}
                        </div>
                        <img class="img" :src="item.logo" />
                        <img :src="item.logo" class="imgBg">
                        <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                            <b>{{item.supplierName}}</b>
                        </div>
                        <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'&&hideHotelInfo!='T'">
                            <b>{{item.hotelName}}</b>
                        </div>
                    </div>
                    <img class="bg" v-if="isItalic=='T'" src="https://xcx.ihotel.cn/mall/images/goods-bg.png" />
                </div>

                <div class="goods-content-common" :class="{'goods-content-square':isSquarePic=='T'}">
                    <div class="goods-name" :class="{'many_goods_name':!(item.extraInfo&&item.extraInfo.discountList&&item.extraInfo.discountList.length>0)}">{{item.name}}</div>
                    <div class="goods-discount" v-if="item.extraInfo&&item.extraInfo.discountList">
                        <div class="goods-discount-item" v-if="item.extraInfo.discountList.length>0" v-for="(discount,j) in item.extraInfo.discountList" :key="j">
                            {{discount.discountTxt}}
                        </div>
                    </div>
                    <template v-if="item.price>=0">
                    <div class="goods-price-credit" v-if="item.price>0&&item.credit>0">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                            <div class="proposedPrice" v-if="item.proposedPrice>0">
                                ¥{{item.proposedPrice}}
                            </div>
                        </div>
                        <div class="credit-box">
                            <span v-if="priceOrCredit!='T'">+</span>{{item.credit}}{{creditName}}<span v-if="priceOrCredit=='T'">兑换</span>
                        </div>
                    </div>
                    <div class="goods-price" v-else-if="item.price>0||(item.skuFlag&&item.price<=0&&item.credit<=0)">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                        </div>

                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>

                    </div>
                    <div class="goods-credit" v-else-if="item.credit>0">
                        <div class="credit-box">
                            <div class="credit">{{item.credit}}</div>
                            <div class="credit-name">{{creditName}}<div class="qi" v-if="item.skuFlag">起</div></div>
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    <div class="goods-price" v-else-if="(item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket')&&item.credit<=0&&item.price<=0">
                        <div class="price-box">
                            <i class="rmb">¥</i>
                            <div class="price">
                                {{item.price}}
                            </div>
                            <div class="qi">起</div>
                        </div>

                    </div>
                    <div class="goods-free" v-else-if="item.credit<=0&&item.price<=0">
                        <div class="free-box">
                            免费
                        </div>
                        <div class="proposedPrice" v-if="item.proposedPrice>0">
                            ¥{{item.proposedPrice}}
                        </div>
                    </div>
                    </template>
                    <div class="goods-ft" v-if="isCloseCart!='T'&&shopCar&&(item.type=='goods'||!item.type)&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                        <div class="add-shopCar" @click.stop="isShowSku(item)">
                            <i class="iconfont iconjia"></i>
                        </div>
                    </div>
                </div>
                <div class="no-stock" v-if="goodsType=='group'&&item.groupStock!=undefined&&item.groupStock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></div>
                <div class="no-stock" v-else-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
            </div>
        </van-cell>
    </div>
    <layerSku ref="layerSku" :goodsId="goodsId" :goodsDetail="goodsDetail" :curInfo="curInfo" showBtn=true></layerSku>
</div>
</template>

<script>
import layerSku from "@/components/layerSku.vue";
import gcTrack from "@/utils/gcTrack";
import {
    getStorage
} from '@/utils/wxuser';
import {
    jAlert3
} from "@/base/jAlert/jAlert";
export default {
    data() {
        return {
            creditName: getStorage('creditName') || '积分',
            isSquarePic: getStorage('isSquarePic') || 'F',
            goodsId: '',
            wxuser: getStorage("wxuser"),
            user: getStorage("user"),
            goodsDetail: {},
            curInfo: {},
            showListHotelName: getStorage('showListHotelName') || 'T',
            customPack:getStorage('customPack')

        };
    },
    props: {
        goodsListData: {
            type: Array
        },
        number: {
            type: Number,
            default () {
                return -1;
            },
        },
        goodsType: {
            type: String,
            default () {
                return "";
            },
        },
        name: {
            type: String,
            default () {
                return '';
            },
        },
        shopCar: {
            type: Boolean,
            default () {
                return true;
            },
        },
       
    },

    filters: {
        keyFilter(val) {
            return val.split(',')[0]
        },
        wordLimit(val) {
            return val.substring(0, 4);
        },

    },
    methods: {
        isShowSku(item) {
             if(!item.id){
                item.id  = item.goodsId
            }
            if(item.id!=this.goodsId){
                this.curInfo = {
                    currentStock: item.stock,
                    currentPrice: item.price,
                    currentCredit: item.credit,
                    currentPic: item.logo
                };
            }
            this.goodsId = item.id;
            this.goodsDetail = item;
            
            if (!this.user || !this.user.memberId) {
                jAlert3("需要登录才能购买商品");
                setTimeout(() => this.isLogin(), 1000);
                return false;
            }

            if (item.stock != undefined && item.stock <= 0) {
                jAlert3("商品已售罄");
                return false;
            }
            if (
                this.user &&
                this.goodsDetail.memberLevelLimit &&
                this.goodsDetail.memberLevelLimit != ""
            ) {
                var memberLevelLimit = this.goodsDetail.memberLevelLimit.split(",");
                var isPassLimit = false;
                memberLevelLimit.forEach((item, i) => {
                    if (this.user.cardLevel == item) {
                        isPassLimit = true;
                    }
                });
                if (!isPassLimit) {
                    jAlert3("会员等级不符合");
                    return false;
                }
            }
            this.$refs.layerSku.isShowSku();
        },
        goGoodsDetail(item, i) {
            var id = item.id || item.goodsId;
            if (this.goodsType == 'hot') {
                var data = {
                    banner_belong_area: '热门推荐',
                    banner_type: '商品',
                    banner_name: item.name,
                    banner_id: id,
                    banner_rank: i + 1
                }
                gcTrack.track("SC_HomeOoperationClick", data)
            }
            if (this.name != '') {
                var data = {
                    key_word: this.$route.query.name,
                    key_word_type: '用户输入',
                    position_number: i,
                    search_result_number: this.totalRows * 1,
                    commodity_id: item.id,
                    commodity_name: item.name
                }
                gcTrack.track("SC_SearchResultClick", data)
            }
            this.$gc.track({
                behaviorType: 7,
                goodsId: id,
                goodsName: item.name || item.goodsName
            });

            if (this.goodsType == 'goodsType') {
                if (item.type == 'goods') {
                    this.$router.push({
                        path: "/goodsDetail",
                        query: {
                            id: item.goodsId
                        },
                    });
                } else {
                    var url = ''
                    if(this.customPack=='5'){
                        url = '/wechat/?/#/hdCombinationInfoDesc?otaChannel=WECHAT&typeCode=PACK&productCode=' + item.productCode +'&packCode='+item.goodsId+'&price='+item.price+'&customPack=5';
                    }else{
                        url = '/wechat/?/#/combinationFree?otaChannel=WECHAT&typeCode=PACK&productCode=' + item.productCode +'&packCode='+item.goodsId+'&price='+item.price;
                    }
                    if (item.type == 'ticket') {
                        url = '/wechat/?/#/ticketInfo?productCode=' + item.productCode +'&scenicSpotCode='+item.scenicSpotCode;
                    }
                    if (item.type == 'pack') {
                        url = '/wechat/?/#/combinationInfoDesc?otaChannel=WECHAT&productCode=' + item.goodsId + "&typeCode=" + item.goodsType + '&price=' + item.memberPrice;
                    }
                    if (item.type == 'room') {
                        if (item.hotelCode == 0) {
                            url = `/wechat/?/#/hotelListNew?otaChannel=WECHAT`;
                        } else {
                            url = `/wechat/?/#/hotel?hotelCode=${item.hotelCode}&hotelGroupCode=${item.hotelGroupCode}`;
                        }
                    }
                    if (item.type == 'scenic') {
                        url = `/wechat/?/#/ticketDetail?code=${item.goodsId}`
                    }
                    window.location.href = url
                }

            } else {
                this.$router.push({
                    path: "/goodsDetail",
                    query: {
                        id: id
                    }
                });
            }

        }
    },
    components: {
        layerSku
    },

    mounted() {

    },
    created() {}
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.goodsListBig_ui {
    .goods-list-big {
        padding: 0 0.266667rem 0;

        .box {
            display: flex;
            position: relative;
            // width: 100%;
            height: 2.666667rem;
            background: #fff;
            margin-top: 0.4rem;
            box-sizing: border-box;
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);

            &.box-square {
                .img-box {
                    .img-box-content {
                        margin-top: 0;
                        margin-left: 0;
                        width: 2.666667rem;
                        height: 2.666667rem;
                    }
                }
            }

            .img-box {
                position: relative;

                .img-box-content {
                    margin-top: 0.266667rem;
                    margin-left: 0.213333rem;
                    background: #fff;
                    height: 2.133333rem;
                    width: 3.2rem;
                    overflow: hidden;
                    position: relative;
                    display: flex;
                    justify-content: center;

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 0.4rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        z-index: 2;

                        b {
                            position: absolute;
                            width: 100%;
                            height: 0.4rem;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            line-height: 0.4rem;
                            text-align: center;
                            padding: 0 0.133333rem;
                        }

                        &::after {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            background: @color-theme;
                            opacity: 0.6;

                        }

                    }

                    .label {
                        position: absolute;
                        z-index: 3;
                        left: 0;
                        top: 0;
                        color: #fff;
                        text-align: center;
                        border-radius: 3px 3px 11px 0px;
                        padding: 0.16rem 0.266667rem 0.16rem 0.16rem;
                        background: @label-color;
                    }

                    .img {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 2;
                        max-width: 100%;
                        max-height: 100%;

                        // border-radius: 0.32rem;
                    }

                    .imgBg {
                        position: absolute;
                        z-index: 1;
                        width: 100%;
                        height: 100%;
                        filter: blur(3px);
                    }
                }

                .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }

            .goods-content-common {
                padding: 0.266667rem;
                flex: 1;

                &.goods-content-square {
                    padding: 0.213333rem 0.266667rem 0;
                }

                .goods-name {
                    font-size: 12px;
                    color: #333333;
                    font-family: PingFangSC-Regular;
                    text-align: left;
                    line-height: 0.533333rem;
                    max-height: 0.533333rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    white-space: normal;
                    overflow: hidden;
                    color: #333333;
                    &.many_goods_name{
                       max-height:1.06666rem;
                       -webkit-line-clamp: 2;
                    }
                }

                .goods-discount {
                    height: 19px;
                    overflow: hidden;
                    width: 3.5rem;

                    .goods-discount-item {
                        border-radius: 2px;
                        color: @color-price;
                        font-size: 10px;
                        margin-top: 5px;
                        border: 1px solid @color-price;
                        display: inline-block;
                        padding: 1px 2px;
                        margin-right: 0.133333rem;
                        white-space: nowrap;
                        margin-right: 0.133333rem;
                    }
                }

                .goods-free {
                    line-height: 1.3;

                    .free-box {
                        font-family: PingFangTC-Regular;
                        font-size: @price-font-size;
                        color: @color-price;
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 10px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }
                .qi {
                    display: inline;
                    font-size: @price-font-size;
                    color: @color-price;
                }
                .goods-price {
                    line-height: 1.3;
                    margin-top: 0.133333rem;

                    .price-box {
                        .rmb {
                            font-family: @price-font-family;
                            font-size: 14px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size;
                            color: @color-price;
                        }
                    }

                    .qi {
                        display: inline;
                        font-size: @price-font-size;
                        color: @color-price;
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 10px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-credit {
                    line-height: 1.3;
                    margin-top: 0.133333rem;

                    .credit-box {
                        .credit {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size;
                            color: @color-price;
                        }

                        .credit-name {
                            display: inline;
                            font-size: 10px;
                            color: @color-price;
                        }
                    }

                    .proposedPrice {
                        margin-top: 0.133333rem;
                        font-size: 10px;
                        color: #888888;
                        font-family: PingFangSC-Regular;
                        text-decoration: line-through;
                    }
                }

                .goods-price-credit {
                    line-height: 1.3;
                    margin-top: 0.133333rem;

                    .price-box {

                        .rmb {
                            font-family: @price-font-family;
                            font-size: 14px;
                            color: @color-price;
                            display: inline;
                        }

                        .price {
                            display: inline;
                            font-family: @price-font-family;
                            font-size: @price-font-size;
                            color: @color-price;
                        }

                        .proposedPrice {
                            display: inline;
                            font-size: 10px;
                            color: #888888;
                            font-family: PingFangSC-Regular;
                            text-decoration: line-through;
                        }
                    }

                    .credit-box {
                        margin-top: 0.133333rem;
                        font-size: 10px;
                        color: @color-credit;
                    }
                }

                .desc {
                    font-size: 10px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .goods-content {
                padding: 0 0.213333rem;
                // height: 3.173333rem;
                text-align: center;

                .goods-name {
                    font-weight: bold;
                    font-size: 1px;
                    text-align: left;
                    height: 1.066667rem;
                    line-height: 0.533333rem;
                    overflow: hidden;
                    color: #333333;
                }

                .desc {
                    font-size: 10px;
                    color: #333333;
                    height: 0.96rem;
                    width: 100%;
                    text-align: left;
                    white-space: normal;
                    line-height: 0.48rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;

                    &.center {
                        text-align: center;
                    }
                }

                .goods-price {

                    display: flex;
                    justify-content: center;
                }

                .btn {
                    display: flex;
                    justify-content: center;
                    margin-top: 0.133333rem;

                    img {
                        width: 2.533333rem;
                        height: 0.48rem;
                    }
                }
            }

            .goods-ft {
                position: absolute;
                bottom: 0.266667rem;
                right: 0.266667rem;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .add-shopCar {
                    text-align: center;
                    font-size: 24px;
                    border-radius: 50%;
                    color: #fff;
                    width: 0.96rem;

                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    i {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: @color-theme;
                        height: 0.56rem;
                        width: 0.56rem;
                        color: #fff;
                        border-radius: 50%;
                        box-shadow: 0 2px 4px 0 rgba(47, 79, 79, 0.08);
                        font-size: 10px;
                    }

                    image {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .no-stock {
                border-radius: 0.106667rem;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                z-index: 2;

                img {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    width: 2.213333rem;
                    height: 1.253333rem;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/goodsListBig.vue